<template>
  <div class="earnings">
    <van-sticky>
      <div
        class="earningsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">收益明细</span>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="content">
        <!-- 体现明细 -->
        <div class="earningsList">
          <van-sticky :offset-top="isiOSX ? 88 : 68">
            <div class="earningsList_top">
              <span @click="dataTimePickerShow = true"
                >{{ dataTimeText
                }}<img src="./../../../assets/decoration/bottom.png" alt=""
              /></span>
              <span @click="dataStatusPickerShow = true"
                >{{ dataStatusText }}
                <img src="./../../../assets/decoration/bottom.png" alt="" />
              </span>
            </div>
          </van-sticky>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <template #finished>
              <div class="finishedTip">
                <div v-if="dataList.length == 0">
                  <img src="./../../../assets/decoration/noData.png" alt="" />
                  <p>暂无相关数据</p>
                </div>
                <div v-else>没有更多了</div>
              </div>
            </template>
            <div class="earningsList_content">
              <div
                class="item"
                v-for="(item, index) in dataList"
                :key="index"
                @click="toEarningsDetails(item)"
              >
                <div>
                  <p>{{ item.created_at }}</p>
                  <span>{{ item.title }}</span>
                </div>
                <div :class="{ isAdd: item.calc_type == 1 }">
                  {{ item.calc_type == 1 ? "+" : "-" }}{{ item.amount }}
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </van-pull-refresh>
    <van-action-sheet v-model="dataTimePickerShow">
      <div class="content">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title="选择年月"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          cancel-button-text="清除"
          @confirm="datetimeConfirm"
          @cancel="datetimeCancel"
        />
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="dataStatusPickerShow" title="选择类型">
      <div class="sheetContent">
        <p
          v-for="(item, index) in actions"
          :class="{ check: item.checkd }"
          :key="index"
          @click="onSelect(index)"
        >
          {{ item.name }}
        </p>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      type: 1, //1代理人，2合伙人
      city_agent_id: null,
      dataStatusText: "全部类型",
      dataTimeText: "全部时间",
      maxDate: new Date(),
      minDate: new Date("2021/01/01"),
      currentDate: new Date(),
      year: null,
      month: null,
      biz_type: null,
      dataStatusPickerShow: false,
      dataTimePickerShow: false,
      actions: [
        { name: "全部类型", value: null, checkd: true },
        { name: "订单结算", value: 1, checkd: false },
        { name: "提现扣减", value: 3, checkd: false },
        { name: "提现驳回", value: 4, checkd: false },
        { name: "手动扣减", value: 2, checkd: false },
        { name: "初始值", value: 0, checkd: false },
      ],
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      dataList: [],
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.city_agent_id) {
      this.city_agent_id = this.$route.query.city_agent_id;
    }
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      this.loading = true;
      let apiUrl = "";
      let params = {};
      if (this.type == 1) {
        apiUrl = "decoration/member/city/agent/balance/record/list";
        params = {
          pageSize: this.pageSize,
          page: this.page,
          city_agent_id: Number(this.city_agent_id),
          biz_type: this.biz_type,
          year: this.year,
          month: this.month,
        };
      } else {
        apiUrl = "decoration/member/city/partner/balance/record/list";
        params = {
          pageSize: this.pageSize,
          page: this.page,
          city_partner_area_id: Number(this.city_agent_id),
          biz_type: this.biz_type,
          year: this.year,
          month: this.month,
        };
      }
      this.$api
        .post(apiUrl, params)
        .then((res) => {
          this.dataList = this.dataList.concat(res.list);
          this.loaded = true;
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch((err) => {
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    onSelect(index) {
      this.actions.forEach((item) => {
        item.checkd = false;
      });
      this.actions[index].checkd = true;
      this.dataStatusText = this.actions[index].name;
      this.biz_type = this.actions[index].value;
      this.dataStatusPickerShow = false;
      this.onRefresh();
    },
    // 收益明细
    toEarningsDetails(item) {
      this.$router.push({
        path: "/decoration/embody/earningsDetails",
        query: {
          data: item,
        },
      });
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    datetimeConfirm(e) {
      this.year = e.getFullYear();
      this.month =
        e.getMonth() + 1 >= 10 ? e.getMonth() + 1 : `0${e.getMonth() + 1}`;
      this.dataTimeText = `${this.year}.${this.month}`;
      this.dataTimePickerShow = false;
      this.onRefresh();
    },
    datetimeCancel(e) {
      this.dataTimePickerShow = false;
      this.year = null;
      this.month = null;
      this.dataTimeText = "全部时间";
      this.onRefresh();
    },
  },
};
</script>
<style lang="less">
.earnings {
  min-height: 100%;
  background: #f5f6ff;
  .earningsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    .earningsList {
      margin-top: 13px;
      .earningsList_top {
        display: flex;
        align-items: center;
        padding: 6px 24px;
        background: #f5f6ff;
        span {
          background: #ffffff;
          border-radius: 13px;
          font-size: 13px;
          color: #666666;
          line-height: 18px;
          padding: 4px 6px 4px 16px;
          display: flex;
          align-items: center;
          margin-right: 20px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 6px;
          }
        }
      }
      .earningsList_content {
        margin: 0 16px;
        .item {
          padding: 16px;
          background: #ffffff;
          border-radius: 8px;
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          div {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            span {
              font-size: 14px;
              line-height: 18px;
              font-weight: normal;
              margin-top: 12px;
              display: inline-block;
            }
            p {
              font-size: 13px;
              color: #999999;
              line-height: 18px;
              font-weight: normal;
            }
          }
          .isAdd{
            color: #5853E9;
          }
        }
      }
    }
  }
  .finishedTip {
    img {
      width: 149px;
      height: 125px;
      margin-top: 64px;
    }
  }
  .sheetContent {
    margin: 12px 0 55px;
    p {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      padding: 12px 0;
      text-align: center;
    }
    .check {
      color: #5853e9;
    }
  }
  .van-action-sheet__header {
    color: #999999;
  }
}
</style>